/*
 * @Author: wyx huapeng Arthur
 * @Date: 2019-04-29 14:34:02
 * @Last Modified by: huapeng
 * @Last Modified time: 2020-07-17 14:04:31
 */
export default class Util {
    static getElementTop(element) {
        var actualTop = element.offsetTop;
        var current = element.offsetParent;

        while (current !== null) {
            actualTop += current.offsetTop;
            current = current.offsetParent;
        }
        return actualTop;
    }

    /**dom has class */
    static addClass(obj, cls) {
        var objClass = obj.className, //获取 class 内容.
            blank = objClass !== "" ? " " : ""; //判断获取到的 class 是否为空, 如果不为空在前面加个'空格'.
        var added = objClass + blank + cls; //组合原来的 class 和需要添加的 class.
        obj.className = added; //替换原来的 class.
    }
    /** dom removeClass */
    static removeClass(obj, cls) {
        var objClass = " " + obj.className + " "; //获取 class 内容, 并在首尾各加一个空格. ex) 'abc    bcd' -> ' abc    bcd '
        objClass = objClass.replace(/(\s+)/gi, " "); //将多余的空字符替换成一个空格. ex) ' abc    bcd ' -> ' abc bcd '
        var removed = objClass.replace(" " + cls + " ", " "); //在原来的 class 替换掉首尾加了空格的 class. ex) ' abc bcd ' -> 'bcd '
        removed = removed.replace(/(^\s+)|(\s+$)/g, ""); //去掉首尾空格. ex) 'bcd ' -> 'bcd'
        obj.className = removed; //替换原来的 class.
    }

    /** dom hasClass */
    static hasClass(obj, cls) {
        var objClass = obj.className, //获取 class 内容.
            objClassLst = objClass.split(/\s+/); //通过split空字符将cls转换成数组.
        var x = 0;
        for (x in objClassLst) {
            if (objClassLst[x] === cls) {
                //循环数组, 判断是否包含cls
                return true;
            }
        }
        return false;
    }
}
